<template>
  <header
    v-if="usedVariant !== 'no-header'"
    v-bind="$attrs"
    class="the-header flex flex-col pb-300 pt-200 gap-200"
  >
    <div class="content-wrap flex justify-between px-200">
      <section class="flex items-center">
        <HyperLink to="/">
          <img
            :alt="shopPublicName"
            :height="32"
            src="~/assets/img/brand/logo-default.svg"
            :width="204"
          />
        </HyperLink>
      </section>

      <TheHeaderStateSwitch v-if="usedVariant !== 'logo-only'" />
    </div>

    <div v-if="usedVariant === 'full'" class="content-wrap h-300 px-200">
      <div class="transition-wrap">
        <TransitionGroup name="fade">
          <TheHeaderBalance v-show="hasBalance" key="balance" />
          <PaymentMethodSymbols
            v-show="!hasBalance"
            key="payment-icons"
            gap-class="gap-100"
          />
        </TransitionGroup>
      </div>
    </div>
  </header>
  <ActiveAnnouncement class="content-wrap px-100 mb-200" />
</template>

<script lang="ts" setup>
type TheHeaderProps = {
  variant?: TheHeaderVariant
}

type TheHeaderVariant = 'full' | 'logo-only' | 'no-balance' | false

const { variant = undefined } = defineProps<TheHeaderProps>()

const hasBalance = useState(StateKey.HasBalance, () => false)

const {
  i18nConfig: { shopPublicName },
} = useRuntimeConfig().public

const usedVariant = computed(() => {
  let { header } = useRoute().meta
  if (typeof variant !== 'undefined') header = variant

  if (typeof header === 'undefined') return 'logo-only'
  if (!header) return 'no-header'
  return header
})
</script>

<style lang="scss" scoped>
.the-header {
  a {
    position: relative;
    display: block;

    @include focus-state {
      &::before {
        inset: -#{token('size/border/200')};
        border-radius: token('size/radius/s');
        box-shadow: 0 0 0 token('size/border/200')
          token('color/border/accent/focused/focused');
      }
    }
  }

  .fade-leave-active {
    position: absolute;
    top: 0;
    left: 0;
  }

  .transition-wrap {
    position: relative;
  }
}
</style>
